import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'

import useTemplatePage from '@hooks/useTemplatePage'

import type { TemplatePageModel } from '@models/types'

import placeholderImageUrl from '../../assets/placeholder.svg'

interface TemplateGalleryGridItemProps {
  templatePage: TemplatePageModel,
}

const TemplateGalleryGridItem = (props: TemplateGalleryGridItemProps) => {
  const {
    templatePage,
  } = props

  const templatePagePayload = useTemplatePage(templatePage)
  const {
    callbacks: {
      templatePageDetails,
    },
    templatePage: {
      id, preview_image, title,
    },
  } = templatePagePayload

  return (
    <Box
      flexDirection="column"
      onClick={() => templatePageDetails()}
      style={{ cursor: 'pointer' }}
      variant="white"
    >
      <Image
        backgroundSize="contain"
        borderRadius="5px 5px 0 0"
        boxProps={{ backgroundColor: 'backgroundColor' }}
        height={220}
        placeholderUrl={placeholderImageUrl}
        url={preview_image}
      />

      <ListItem
        boxProps={{
          borderBottom: '1px dashed', borderTop: '1px solid', padding: 'large',
        }}
        showAngleIcon
      >
        <Box flexDirection="column" paddingRight="medium">
          <Text fontSize="small" variant="ellipsis">{title}</Text>

          <Text fontSize="xsmall" color="mysteryGrey" marginTop="small">{`Page #${id}`}</Text>
        </Box>
      </ListItem>
    </Box>
  )
}

export default TemplateGalleryGridItem
